import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDriversByPlateNumber } from '../../hooks/react-query/useDrivers';
import { CustomModal } from '../ui';
import { CarIcon, GasPump, ServiceIcon, SpinnerIcon } from '../../icons';
import { Rounded } from '../elements/rounded';
import { useServiceCarStore } from '../../store/serviceCarStore';
import AsignedDriversCard from './asignedDriversCard';
import CarAssignMessage from './carAssignMessage';
import { checkBookingEnabled, checkDriverManage } from '../../utils/helper';
import BookAServiceInfoModal from '../elements/bookAServiceInfoModal';

const EditCarView = ({ selectedCar, handleAssignClick }) => {
  const [openModal, setOpenModal] = useState(false);
  const { FuelType, ModelName, MakeName, plateno, actions } = selectedCar || {};
  const isDriverManage = checkDriverManage(actions);

  const isBookingEnabled = checkBookingEnabled(actions);

  const navigate = useNavigate();
  const { setCarInfo } = useServiceCarStore();

  const { data: carDetails, isLoading } = useDriversByPlateNumber(
    plateno,
    isDriverManage
  );
  const { data = [] } = carDetails || {};
  const dataLength = data.length;

  return (
    <>
      {isDriverManage && isLoading && <SpinnerIcon />}
      <CustomModal
        blurred={false}
        triggerClass="flex items-center justify-center"
        triggerComponent={
          <div className="h-[1px] w-[60px] bg-fadedgrey self-center"></div>
        }
        handleClick={(value) => setOpenModal(value)}
        openModal={openModal}
        wrapperClass="max-lg:h-full"
      >
        <div className="container-sm mx-auto gap-4 flex flex-col lg:py-10 py-5 max-lg:px-5">
          <div className="flex flex-col gap-2">
            <button
              type="button"
              className="self-center"
              onClick={() => setOpenModal(false)}
            >
              <div className="h-[1px] w-[60px] bg-fadedgrey "></div>
            </button>
            <CarDetails
              selectedCar={selectedCar}
              isBookingEnabled={isBookingEnabled}
            />

            {isDriverManage && !!dataLength ? (
              <>
                <div className="flex justify-between lg:px-6 py-3">
                  <h4>Οδηγοί Αυτοκινήτου</h4>
                  <button
                    type="button"
                    className="text-secondary-button text-primary"
                    onClick={() => {
                      setOpenModal(false);
                      handleAssignClick();
                    }}
                  >
                    Προσθήκη οδηγού
                  </button>
                </div>
                <div className="flex gap-3 lg:px-6 overflow-x-auto pb-3">
                  {data.map((details) => {
                    return (
                      <AsignedDriversCard
                        driverDetails={details}
                        key={details.id}
                        plateNumber={plateno}
                        carName={MakeName + ' ' + ModelName}
                      />
                    );
                  })}
                </div>
              </>
            ) : (
              isDriverManage && (
                <CarAssignMessage
                  handleAssignClick={() => {
                    setOpenModal(false);
                    handleAssignClick();
                  }}
                />
              )
            )}
          </div>
        </div>
      </CustomModal>
      <div className="flex justify-between">
        <h4>{MakeName}</h4>
        {isBookingEnabled ? (
          <button
            type="button"
            className="text-link text-primary"
            onClick={() => {
              navigate('/service-booking');
              setCarInfo(selectedCar);
            }}
          >
            <ServiceIcon stroke={'black'} classsName={'rounded-full border border-[#A5A5A5] h-8 w-8 p-1'} />
          </button>
        ) : (
          <BookAServiceInfoModal showIcon={true} />
        )}
      </div>
      <div className="flex items-center gap-2">
        <div className="flex items-center justify-center gap-1">
          <CarIcon color="black" />
          <span className="text-body">{ModelName}</span>
        </div>
        <div className="flex items-center justify-center gap-1">
          <GasPump /> <span className="text-body">{FuelType}</span>
        </div>
      </div>
    </>
  );
};

const CarDetails = ({ selectedCar, isBookingEnabled }) => {
  const navigate = useNavigate();
  const { setCarInfo } = useServiceCarStore();

  const { EndDate, FuelType, BodyType, MakeName, ModelName, plateno, Color, VIN, CreditFacilityCode } = selectedCar || {};

  return (
    <div className="grid border border-fadedgrey rounded-[12px] p-5">
      <div className="flex gap-2 items-center pb-2 border-b border-b-fadedgrey">
        <Rounded className="bg-powdergrey p-3">
          <CarIcon color="black" />
        </Rounded>
        <h3>{MakeName} {ModelName}</h3>
      </div>      
      <div className="flex justify-between py-3">
        <h6>Αριθμός Πινακίδας</h6>
        <div>{plateno}</div>
      </div>
      <div className="flex justify-between py-3">
        <h6>Τύπος Αυτοκινήτου</h6>
        <div>{BodyType}</div>
      </div>
      <div className="flex justify-between py-3">
        <h6>Τύπος Καυσίμου</h6>
        <div>{FuelType}</div>
      </div>
      <div className="flex justify-between py-3">
        <h6>Λήξη Συμβολαίου </h6>
        <div>{EndDate.split('-')[2] +'/'+ EndDate.split('-')[1] +'/'+ EndDate.split('-')[0]}</div>
      </div>
      <div className="flex justify-between py-3">
        <h6>Χρώμα</h6>
        <div>{Color}</div>
      </div>
      <div className="flex justify-between py-3">
        <h6>VIN</h6>
        <div>{VIN}</div>
      </div>
      <div className="flex justify-between py-3">
        <h6>Αριθμός παραρτήματος</h6>
        <div>{CreditFacilityCode}</div>
      </div>
      {isBookingEnabled ? (
        <button
          type="button"
          className="btn-secondary text-secondary-button"
          onClick={() => {
            navigate('/service-booking');
            setCarInfo(selectedCar);
          }}
        >
          Ραντεβού Service
        </button>
      ) : (
        <BookAServiceInfoModal />
      )}
    </div>
  );
};

export default EditCarView;
